
class Filters extends HTMLElement {
    constructor() {
        super()
        this.handleSize()
        window.addEventListener("resize", () => this.handleSize())
    }

    handleSize() {
        const filter = document.getElementById(this.id)
        const filterBody = filter.getElementsByClassName('ml_filter_body')?.[0];
        if(document.querySelector("#Filter_Mobile_btn") && window.innerWidth <= 750) {
            document.querySelector("#Filter_Mobile_btn").onclick = (e) => {
                const classFilter = document.querySelector("#Filter_Container")?.classList;
                if(classFilter?.contains("ml_filter_hide") && window.innerWidth <= 750) {
                    const bottomBar = document.getElementById("mobile_nav");
                    const bottomBarHeight = bottomBar?.clientHeight || 0;
                    const collapserPostion = document.querySelector("#Filter_Container")?.getBoundingClientRect()?.y || 0;
                    const total = collapserPostion + bottomBarHeight;
                    document.querySelector("#Filter_Container").style.height = `calc(100svh - ${total}px)`
                } else {
                    document.querySelector("#Filter_Container").style.height = '';
                }
                
                document.querySelector("#Filter_Container")?.classList.toggle("ml_filter_hide");  
                if(window.innerWidth <= 750) {
                    document.body.classList.toggle("ml_fix_body");
                } else {
                    document.body.classList.remove("ml_fix_body");
                }
                document.querySelector("#Filter_Mobile_btn")?.querySelector(".ml_filter_collapser_arrow")?.classList.toggle("ml_rotate_arrow_filter");
            };
        }
    }

    toggle() {
        const filter = document.getElementById(this.id)
        const filterBody = filter.getElementsByClassName('ml_filter_body')?.[0]
        const filterIcon = filter.getElementsByClassName('ml_filter_icon')?.[0]
        filterBody.classList.toggle('expand')
        filterBody.style.height = filterBody.classList.contains('expand') ? filterBody.scrollHeight + 'px' : 0
        filterIcon.classList.toggle('expand_icon')
    }
}

customElements.define('ml-filters', Filters);
